const isProd = import.meta.env.MODE === 'production';

// En desarrollo, sin VITE_API_URL se usa el proxy de Vite `/Backend` (mismo origen, sin CORS); ver vite.config.ts.
const DEV_API_URL = '/Backend/api';

const RUNTIME = isProd
  ? window.RUNTIME_CONFIG
  : {
      VITE_API_URL: import.meta.env.VITE_API_URL || DEV_API_URL,
      VITE_ENTORNO: import.meta.env.VITE_ENTORNO,
      VITE_FILESERVER: import.meta.env.VITE_FILESERVER,
      VITE_PUSHER_KEY: import.meta.env.VITE_PUSHER_KEY,
      VITE_PUSHER_CLUSTER: import.meta.env.VITE_PUSHER_CLUSTER,
      VITE_POWER_BY_AUDIENCIA: import.meta.env.VITE_POWER_BY_AUDIENCIA,
    };

export const origin = RUNTIME.VITE_API_URL;
export const keyEntorno = RUNTIME.VITE_ENTORNO;
export const keyFileServer = RUNTIME.VITE_FILESERVER;
export const pusherKey = RUNTIME.VITE_PUSHER_KEY;
export const pusherCluster = RUNTIME.VITE_PUSHER_CLUSTER;
export const powerByAudiencia = RUNTIME.VITE_POWER_BY_AUDIENCIA;

export function buildApiUrl(path: string, base: string = origin) {
  return `${base}${path}`;
}

export const singleProfile = 1;

export const defaultValues = {
  country: { value: 'yBb7HXS%2br%2byLLxGbeakT1A%3d%3d', label: 'Perú' },
  region: { value: 'rUHof5%2be1tnIUZXwVll5MA%3d%3d', label: 'Lima' },
  mediaType: {
    value: 'wE%2fVeX6fRvcguGvIf0BRTA%3d%3d',
    label: 'Televisión',
  },
};
